<template>
  <main class="questionLists" aria-label="我的答题">
    <section class="login-box" v-if="showLoginBtn && !isInApp">
      <Auth
        :height="dynamicHeight"
        ableContact="true"
        @handleContact="handleContact"
        @loginClick="loginClick"
      />
    </section>

    <van-tabs
      v-else
      v-model="type"
      sticky
      color="#1890FF"
      title-active-color="#1890FF"
      @click.capture="changeTab"
    >
      <van-tab
        v-for="(item, index) in tabLists"
        :key="item.type"
        :title="item.title"
      >
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <div
            class="tip"
            v-if="index == 2 && isInApp"
            @click="refreshClick(1)"
          >
            <div class="flexCenterCenter">
              <img
                class="refresh-icon"
                src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220905/2022-09-05/a562121fa24564a53eb937a35e875001.svg"
                alt=""
              />已完成创建，仍未展示新建答题？
            </div>
            <div>点击刷新同步</div>
          </div>
          <section class="qlsearch-box" v-if="(type == 2 || type == 1) && !isInApp">
            <div class="handleType" @click="handleActionSheet(0, true)">
              {{ typeLists[quesTypeIndex].name }}
              <img
                class="handleType-icon"
                src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2023-01-04/0b288c3890a38b88153dc97cf8ba5b66.png"
              />
            </div>
            <div class="qlsearch-bd">
              <img
                class="iconfont icon-search"
                src="https://cdn.zhinizhushou.com/material/2024-05-27/9f059f241e96d392d906e0e28608482c.svg"
                alt=""
              />
              <form class="qlsearch-bd-input" action="javascript: return true">
                <input
                  class="qlsearch-input"
                  type="search"
                  v-model="keyword"
                  @blur="searchBlur"
                  @focus="handlePlaceholder"
                  @keyup.enter="search"
                  placeholder="搜索我的答题"
                  enter
                />
              </form>
              <img
                v-if="keyword !== ''"
                @click="clearKeyword"
                class="search-clear-icon"
                src="https://cdn.huomaqun.com/material/2024-01-25/787986a00e2977d9bbbe829b11c47b0e.png"
                alt=""
              />
            </div>
            <!-- <div class="recovery flexCenter" @click="toRecovery">
              <span class="recovery-count" v-if="recycle_total > 0">{{
                recycle_total >= 100 ? "99+" : recycle_total
              }}</span>
              <img
                class="recovery-btn"
                src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2023-07-28/ce7452ef6a3151518c4fe6a872a96e64.svg"
              />
              回收站
            </div> -->
          </section>
          <van-list
            v-model="loading"
            :finished="finished"
            :immediate-check="false"
            finished-text=""
            @load="onLoad"
          >
            <section class="list-box" aria-label="答题列表">
              <div
                class="list-bd wrongcard-wrap"
                v-if="!isInApp && loaded && (type == 0 || type == 1)"
              >
                <WrongCard
                  type="questionlist_open_wrongbook"
                  name="我参与的页面点击进去错题本"
                  :total_wrong_count="total_wrong_count"
                />
              </div>
              <div
                v-for="(item, index) in lists"
                class="list-bd"
                :class="{'noborder': type != 2 && index == 0}"
                :key="index"
                @click="toDetail(item)"
              >
                <div class="list-icon-bd" @click.stop="toDetail(item)">
                  <img
                    class="list-icon"
                    :src="item.banner || default_banner"
                    @click.stop="toDetail(item)"
                    mode="aspectFill"
                  />
                  <div
                    class="typeBox r"
                    v-if="item.temp != 0 && item.temp != 5"
                  >
                    <img class="type-icon" :src="typeIcons[item.temp].icon" />{{
                      typeIcons[item.temp].label
                    }}
                  </div>
                </div>
                <div class="list-right" @click.stop="toDetail(item)">
                  <div class="title-part">
                    <div class="list-text" @click.stop="toDetail(item)">
                      {{ item.title }}
                    </div>
                    <img
                      @click.stop="handleActionSheet(index)"
                      v-if="type == 2"
                      src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2023-01-04/8b1397b00ab342f7bc3c507348e60ad0.png"
                      class="handle-btn"
                    />
                  </div>

                  <div
                    :class="
                      type === 0 ? 'list-count' : 'list-count flexCenterBetween'
                    "
                  >
                    <template>
                      <template v-if="type == 1">
                        <label v-if="item.temp == 3">已参与</label>
                        <label v-else>最高分：{{ item.score }}</label>
                      </template>
                      <template v-else>
                        <label
                          v-if="item.temp == 2 || !item.total_join_limit"
                          :class="
                            item.total_join_limit > 0 && item.joined >= item.total_join_limit ||
                            item.joined_limit > 0 &&
                            item.joined >= item.joined_limit
                              ? 'red partner-box'
                              : 'partner-box'
                          "
                        >
                          <img
                            class="partner"
                            :src="
                              item.total_join_limit > 0 && item.joined >= item.total_join_limit ||
                              item.joined_limit > 0 &&
                              item.joined >= item.joined_limit
                                ? 'https://cdn-xcx-qunsou.weiyoubot.cn/material/20220810/2022-08-10/63f7117e378238bf2ee4c8ef3d141999.svg'
                                : 'https://cdn-xcx-qunsou.weiyoubot.cn/material/20220810/2022-08-10/d347a5ba0557d16dac226c0a04302c57.svg'
                            "
                            mode="aspectFill"
                          />{{ item.total_join_limit > -1 ? transNumWan(item.total_join) : transNumWan(item.joined)
                          }}<template v-if="item.joined_limit || item.total_join_limit > -1"
                            >/{{
                              item.total_join_limit > -1 ?transNumWan(item.total_join_limit) : 
                              item.joined_limit == -1
                                ? "无限制"
                                : transNumWan(item.joined_limit)
                            }}<template
                              v-if="
                                item.total_join_limit > 0 && item.joined >= item.total_join_limit ||
                                item.joined_limit > 0 &&
                                  item.joined >= item.joined_limit
                              "
                              >已达上限</template
                            >
                          </template>
                        </label>
                        <label
                          v-else
                          :class="
                            item.total_join_limit > 0 &&
                            item.total_join >= item.total_join_limit
                              ? 'red partner-box'
                              : 'partner-box'
                          "
                        >
                          <img
                            class="partner"
                            :src="
                              item.total_join_limit > 0 &&
                              item.total_join >= item.total_join_limit
                                ? 'https://cdn-xcx-qunsou.weiyoubot.cn/material/20220810/2022-08-10/63f7117e378238bf2ee4c8ef3d141999.svg'
                                : 'https://cdn-xcx-qunsou.weiyoubot.cn/material/20220810/2022-08-10/d347a5ba0557d16dac226c0a04302c57.svg'
                            "
                            mode="aspectFill"
                          />{{ transNumWan(item.total_join)
                          }}<template v-if="item.total_join_limit"
                            >/{{
                              item.total_join_limit == -1
                                ? "无限制"
                                : transNumWan(item.total_join_limit)
                            }}<template
                              v-if="
                                item.total_join_limit > 0 &&
                                  item.total_join >= item.total_join_limit
                              "
                              >已达上限</template
                            >
                          </template>
                        </label>
                      </template>
                      <label
                        :class="
                          item.ques_status == 1 && !item.del ? 'btn-ok' : ''
                        "
                        >{{
                          item.del
                            ? "已删除"
                            : item.ques_status === 0
                            ? "未开始"
                            : item.ques_status == 1
                            ? "进行中"
                            : "已结束"
                        }}</label
                      >
                      <!-- <label
                        v-if="
                          !(
                            item.is_admin &&
                            (item.is_violation || item.is_audit == 2)
                          )
                        "
                        class="more-btn"
                        @click.stop="handleActionSheet(index)"
                      >
                        更多操作>1212
                      </label> -->
                    </template>
                  </div>
                </div>
              </div>
              <div class="see-end" v-if="type == 0 && lists.length == 20">
                仅展示最近浏览的20个答题活动
              </div>
            </section>
          </van-list>
          <footer v-if="lists.length" class="contact-wrapper">
            <Contact />
          </footer>
          <section v-else class="noData" aria-label="空状态">
            <div class="contact">
              <Contact />
            </div>
            <div v-if="type == 1">暂无答题记录</div>
            <template v-if="type === 2">
              <div @click="toIntro" class="toIntro">
                还没有管理的答题<span class="themeColor">立即创建一个</span>
              </div>
            </template>
          </section>
        </van-pull-refresh>
      </van-tab>
    </van-tabs>
    <aside
      class="recovery-boxpr"
      aria-label="回收站入口"
      v-if="(type == 2 || (type == 0 && recycle_total > 0)) && !isInApp"
    >
      <div class="recovery-box" @click="toRecovery">
        <div class="recovery flexCenter">
          <span class="recovery-count" v-if="recycle_total > 0">{{
            recycle_total >= 100 ? "99+" : recycle_total
          }}</span>
          <img
            class="recovery-btn"
            src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2023-07-28/ce7452ef6a3151518c4fe6a872a96e64.svg"
          />
          回收站
          <WxLink
            v-if="isWeixin && isMobile"
            wxPath="/subPages/pages/recovery/recovery"
          />
        </div>
      </div>
    </aside>

    <ContactImg :visible="showContact" @hideVisible="handleContact()" />
    <van-action-sheet
      v-model="show"
      class="question-list-sheet"
      :actions="actions"
      cancel-text="取消"
      close-on-click-action
      @select="onSelect"
      close-on-popstate
    />
    <footer>
      <FooterTab :activeIndex="2" />
    </footer>
    <template v-if="showLogin">
      <ScanLogin @hideVisible="handleScan()" :src="loginQrcode"> </ScanLogin>
    </template>
    <van-popup
      v-model="showVersionTip"
      :style="{ borderRadius: '8px', width: '320px' }"
      closeable
      close-icon="close"
      @closed="showVersionTip = false"
    >
      <ImgDialog
        src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20211013/986befc70730defd7e2e5bd2272a393b.png"
      />
    </van-popup>
  </main>
</template>

<script>
import questionOnly from "@/utils/questionOnly";
import api from "@/utils/api";
import Contact from "@/components/contact";
import ContactImg from "@/components/contactImg";
import NavBar from "@/components/navbar";
import FooterTab from "@/components/footerTab";
import ScanLogin from "@/components/scanLogin";
import WrongCard from "../../components/wrongCard.vue";
import ImgDialog from "@/components/common/imgDialog.vue";
import Auth from "@/components/common/auth.vue";
import WxLink from "@/components/wxLink.vue";
import { Dialog, Toast } from "vant";
import {
  getToken,
  setShareInfo,
  reLogin,
  copyTemp,
  tabIcon,
  getQueryString,
  getBindToken,
  deepClone,
  isMobile,
  verifyAuth,
  isWeixin,
  getWxUrl,
  showServiceAble,
  handleCode
} from "@/utils/common";
import { default_banner, typeIcons } from "@/utils/config";
import { handleZI, randomString } from "../../utils/common";
let intervalAsk;
let checkTime = 0;

export default {
  data() {
    return {
      quesTypeIndex: 0,
      typeLists: [
        { name: "全部", value: "", index: 0, status: 1 },
        { name: "进行中", value: 1, index: 1, status: 1 },
        { name: "已结束", value: 2, index: 2, status: 1 },
        { name: "未开始", value: 0, index: 3, status: 1 }
      ],
      typeIcons: typeIcons,
      settingUrl: "",
      showVersionTip: false,
      recycle_total: 0,
      keyword: "",
      loaded: false,
      total_wrong_count: 0,
      tabsIndex: "question",
      showContact: false,
      type: 0,
      refreshing: false,
      loading: false,
      finished: true,
      pageSize: 20, //每页请求的数量
      total: 0, //总共的数据条数
      itemList: [],
      page: 1,
      lists: [],
      tabLists: [
        { title: "最近浏览", type: 9 },
        { title: "我参与的", type: 2 },
        { title: "我管理的", type: 0 }
      ],
      practice_icon:
        "https://cdn-xcxcustom.weiyoubot.cn/20200914/ddde099549834d75a4f59e8653e8561e.png",
      practice_daily_icon:
        "https://cdn-xcxcustom.weiyoubot.cn/20200927/044ac8596272ad1522a590682bb8379a.png",
      question_icon:
        "https://cdn-xcxcustom.weiyoubot.cn/20201214/c18c9f5a108aa25273ac830ab45ffe6c.png",
      award_icon:
        "https://cdn-xcxcustom.weiyoubot.cn/20210112/0c3abae86bce25f18b6ac0d5c7c36ebb.png",
      card_icon:
        "https://cdn-xcx-qunsou.weiyoubot.cn/material/2023-02-02/352a1e720639324feac2a3b9559a2c75.svg",
      isInApp: wemeet.app.isTMWebview(),
      active: 0,
      tabIcon: tabIcon,
      default_banner,
      show: false,
      actions: [],
      targetIndex: -1,
      showLogin: false,
      loginQrcode: "",
      isMobile: isMobile(),
      isWeixin: isWeixin(),
      showSearchTip: true,
      showLoginBtn: false,
      wxlistUrl: "",
      dynamicHeight: 0
    };
  },
  mounted() {
    document.title = "立吉答题";
    if (this.isInApp) {
      // if (!getToken()) {
      //   return this.$router.replace({ name: "intro" });
      // }
      setShareInfo();
      this.handleRelogin();
    } else {
      // 非腾讯会议页面
      this.getHeaderHeight();
      // if (!getToken()) return reLogin();
    }
    if (localStorage.getItem("info")) localStorage.removeItem("info");
  },
  destroyed() {
    if (intervalAsk) {
      clearTimeout(intervalAsk);
      intervalAsk = null;
    }
    if (localStorage.getItem("qid")) localStorage.removeItem("qid");
    if (localStorage.getItem("template_id"))
      localStorage.removeItem("template_id");
    if (localStorage.getItem("rank")) localStorage.removeItem("rank");
    if (localStorage.getItem("personal")) localStorage.removeItem("personal");
  },
  methods: {
    transNumWan(num) {
      if (typeof num !== "number") {
        num = parseFloat(num);
      }
      if (isNaN(num)) {
        return "0";
      }
      if (num < 10000) {
        return num;
      }
      // 直接截断到小数点后一位，不进行四舍五入
      var divided = num / 10000;
      var integerPart = Math.floor(divided);
      var decimalPart = Math.floor((divided - integerPart) * 10);
      if (decimalPart === 0) {
        return integerPart + "万";
      }
      return integerPart + "." + decimalPart + "万";
    },
    // 点击按钮登录啊
    async loginClick() {
      if (this.isMobile) {
        // mobile
        if (this.isWeixin) {
          // wx env
          reLogin();
        } else {
          if (!this.wxlistUrl) {
            let res = await getWxUrl("pages/questionlist/questionlist", "", 1);
            if (res) {
              this.wxlistUrl = res;
            }
          }
          window.location.href = this.wxlistUrl;
        }
      } else {
        // pc
        this.getLoginCode();
      }
    },
    // 搜索框聚焦
    handlePlaceholder() {
      this.showSearchTip = false;
    },
    // 搜索框失去焦点
    searchBlur() {
      let val = this.keyword.trim();
      if (val === "") {
        this.showSearchTip = true;
      }
    },
    // 关键字搜索
    search() {
      this.page = 1;
      this.getList(1, 1);
    },
    async toRecovery() {
      if (this.isMobile) {
        if (!this.settingUrl) {
          let res = await getWxUrl("subPages/pages/recovery/recovery", "", 1);
          if (res) {
            this.settingUrl = res;
          }
        }
        window.location.href = this.settingUrl;
        return;
      } else {
        this.showVersionTip = true;
      }
    },
    clearKeyword() {
      this.keyword = "";
      this.showSearchTip = true;
      this.getList(1, "chageType");
    },
    async getLoginCode() {
      if (this.isWeixin) {
        reLogin();
      } else {
        var timestamp = new Date().getTime();
        var myToken =
          timestamp + Math.ceil(Math.random() * 1000000000000000) + "";
        // 获取二维码  开始轮询请求，如果返回ok，清除轮询
        questionOnly
          .get("/xcx/ques_web/v1/qrcode", { token: myToken })
          .then(res => {
            if (res.sta == 0) {
              this.loginQrcode = res.data.qrcode;
              if (!this.showLogin) this.showLogin = true;
              checkTime = 0;
              this.checkLoginSuccess(myToken);
            } else {
              Toast(res.msg || "请求失败");
            }
          });
      }
    },
    checkLoginSuccess(myToken) {
      clearTimeout(intervalAsk);
      checkTime++;
      if (checkTime > 20) {
        checkTime = 0;
        this.getLoginCode();
        return;
      }
      questionOnly
        .get("/xcx/ques_web/v1/check_status", {
          token: myToken,
          loadingMsg: "no"
        })
        .then(res => {
          if (res.sta === -1) {
            intervalAsk = setTimeout(() => {
              this.checkLoginSuccess(myToken);
            }, 3000);
          } else {
            // 登录成功
            this.showLoginBtn = false;
            localStorage.setItem("token", res.data.access_token);
            handleZI(res.data.mp_openid);
            setTimeout(async () => {
              this.showLogin = false;
              this.getList();
            }, 100);
          }
        });
    },
    handleScan() {
      if (intervalAsk) {
        clearInterval(intervalAsk);
        intervalAsk = null;
      }
      this.showLogin = !this.showLogin;
    },
    handleActionSheet(index, choose) {
      let actionsList = [];
      if (choose) {
        actionsList = this.typeLists;
        // 筛选答题类型
      } else {
        this.targetIndex = index;
        let { is_audit } = this.lists[index];
        actionsList = [{ name: "删除答题" }];
        if (is_audit !== 2) {
          actionsList = [{ name: "答题记录" }, { name: "修改设置" }].concat(
            actionsList
          );
          if (this.isInApp)
            actionsList = [{ name: "邀请会中成员答题" }].concat(actionsList);
        }
      }

      this.actions = actionsList;
      this.show = true;
    },
    handleShow() {},
    onSelect(val) {
      let { name, status, index } = val;
      if (status) {
        this.quesTypeIndex = index;
        this.getList(1, "chageType");
      } else {
        if (["答题记录", "修改设置"].indexOf(name) > -1) {
          this.$router.push({ name: "helpCenter" });
        } else if (name === "删除答题") {
          Dialog.confirm({
            message: "是否确认删除答题，删除后答题内所有数据都将被清除",
            confirmButtonColor: "1890ff"
          })
            .then(() => {
              this.deleteItem();
            })
            .catch(() => {});
        } else if (name === "邀请会中成员答题") {
          localStorage.setItem("detailShare", true);
          let name =
            this.lists[this.targetIndex].temp === 5
              ? "tacitDetail"
              : "normalDetail";
          this.$router.push({
            name: name,
            query: { qid: this.lists[this.targetIndex].qid }
          });
        }
      }
    },
    refreshClick() {
      this.getList(1, "chageType", true);
      if (localStorage.getItem("bind_status") == 1) {
        setTimeout(() => {
          Toast("已刷新");
        }, 500);
      } else {
        Dialog.confirm({
          message: "微信扫码登录后，才能同步已创建的答题活动呦",
          confirmButtonText: "去绑定",
          confirmButtonColor: "1890ff"
        })
          .then(() => {
            reLogin("sync");
          })
          .catch(() => {
            // on cancel
          });
      }
    },
    toIntro() {
      this.$router.push({
        name: "intro"
      });
    },
    toDetail(item) {
      let { qid, temp } = item;
      let name = temp === 5 ? "tacitDetail" : "normalDetail";
      this.$router.push({ name: name, query: { qid: qid } });
    },
    async handleContact() {
      let res = await showServiceAble();
      if (res) {
        this.showContact = !this.showContact;
      }
    },
    onRefresh() {
      this.getList(1, "chageType");
    },
    changeTab(refresh = 0) {
      this.keyword = "";
      this.showSearchTip = true;
      this.getList(1, "chageType", refresh);
    },
    onLoad() {
      this.getList(this.page + 1);
    },
    getList(page = 1, changeType) {
      this.page = page;
      let param = {
        access_token: getToken(),
        page,
        count: this.pageSize,
        type: this.type == 0 ? 9 : this.type == 1 ? 2 : 0,
        ...(this.type != 0 ? { title: this.keyword } : {}),
        ...(this.quesTypeIndex > 0
          ? {
              ques_status: this.typeLists[this.quesTypeIndex].value
            }
          : {})
      };
      if(localStorage.getItem('toWrong')) {
        param.reload = randomString(6);
        param.page = 1;
        this.page = 1;
        changeType = 1;
        localStorage.removeItem('toWrong')
      }
      questionOnly.get(api.question.getList, param).then(res => {
        this.loaded = true;
        this.loading = false;
        this.refreshing = false;
        if (res.sta == 0) {
          this.lists = changeType
            ? res.data.lists
            : this.lists.concat(res.data.lists);
          if (!res.data.lists.length) {
            this.finished = true;
          } else {
            this.finished = false;
          }
          this.recycle_total = res.data.recycle_total;
          this.total_wrong_count = res.data.total_wrong_count;
        } else if (res.sta === -500) {
          if (!this.isInApp && !this.isMobile) {
            this.getLoginCode();
          } else {
            reLogin(
              "",
              localStorage.getItem("bind_status") != 1 ? "/questionList" : ""
            );
          }
        } else {
          Toast(res.msg);
        }
      });
    },
    handleRelogin() {
      if (localStorage.getItem("qid")) {
        let storageData = JSON.parse(localStorage.getItem("qid"));
        if (storageData.qid) {
          localStorage.removeItem("qid");
          this.$router.push({
            name: storageData.type === 5 ? "tacitDetail" : "normalDetail",
            query: { qid: storageData.qid }
          });
        }
      }
      if (localStorage.getItem("template_id")) {
        let storageData = JSON.parse(localStorage.getItem("template_id"));
        if (storageData.qid) {
          copyTemp({ qid: storageData.qid, temp_id: storageData.temp_id }).then(
            res => {
              localStorage.removeItem("template_id");
              this.$router.push({
                name: storageData.type === 5 ? "tacitDetail" : "normalDetail",
                query: { qid: res.qid }
              });
            }
          );
        }
      }
      if (localStorage.getItem("rank")) {
        let storageData = JSON.parse(localStorage.getItem("rank"));
        if (storageData.qid) {
          this.$router.push({
            name: "rank",
            query: { qid: res.qid }
          });
        }
      }
      if (localStorage.getItem("personal")) {
        this.$router.push({ name: "personal" });
      }
      if (localStorage.getItem("detailShare"))
        localStorage.removeItem("detailShare");
    },
    changeTabIndex(val) {
      if (val === "intro") {
        this.tabsIndex = "question";
        this.$router.push({ name: "intro" });
      }
    },
    deleteItem() {
      let param = {
        qid: this.lists[this.targetIndex].qid,
        access_token: getToken()
      };
      questionOnly.post("/xcx/ques/v1/remove", param).then(res => {
        if (res.sta == 0) {
          let copyData = deepClone(this.lists);
          copyData.splice(this.targetIndex, 1);
          this.lists = copyData;
          Toast("删除成功");
        } else if (res.sta === -500) {
          reLogin(
            "",
            localStorage.getItem("bind_status") != 1 ? "/questionList" : ""
          );
        } else {
          Toast(res.msg);
        }
      });
    },
    getHeaderHeight() {
      let tabbarHeight = document.querySelector(".tabbar").offsetHeight || 0;
      this.dynamicHeight = `calc(100vh - ${tabbarHeight}px)`;
    }
  },
  components: {
    Contact,
    ContactImg,
    NavBar,
    FooterTab,
    ScanLogin,
    WrongCard,
    ImgDialog,
    Auth,
    WxLink
  },

  async created() {
    if (this.isInApp && getQueryString("auth_code")) {
      let res = await getBindToken(getQueryString("auth_code"));
      if (res) {
        localStorage.setItem("token", res.access_token);
        localStorage.setItem("bind_status", res.bind_status || 0);
        this.$router.replace({
          name: "questionList"
        });
        this.getList();
      }
      return;
    }
    if (getQueryString("ut")) {
      this.type = 0;
      localStorage.setItem("token", getQueryString("ut"));
      setTimeout(() => {
        this.getList();
      }, 500);
      return;
    }
    if(localStorage.getItem('toWrong')) {
      this.getList();
      return;
    }
    let loginStatus = await verifyAuth();
    if (!this.isInApp && !loginStatus && getQueryString("code")) {
      let res = await handleCode(getQueryString("code"));
      if (res) {
        this.$router.replace({
          name: "questionList"
        });
        this.getList();
        this.showLoginBtn = false;
      }
      return;
    }
    if (!this.isInApp && !loginStatus) {
      if (!isMobile()) {
        // pc 未登录
        if (!this.isWeixin) {
          this.showLoginBtn = true;
          this.getLoginCode();
        } else {
          if (getToken()) {
            reLogin();
          } else {
            this.showLoginBtn = true;
          }
        }
      } else {
        if (this.isWeixin) {
          // 微信环境
          if (getToken()) {
            reLogin();
          } else {
            this.showLoginBtn = true;
          }
        } else {
          this.showLoginBtn = true;
        }
      }
      return;
    }
    this.getList();
  }
};
</script>
<style lang="scss">
.question-list-sheet.van-popup--bottom {
  left: 0;
  right: 0;
  width: 100%;
  max-width: 500px;
  min-width: 320px;
  margin: 0 auto;
}
</style>
<style lang="scss" scoped>
@function rem($px) {
  @return $px / 75 + rem;
}
main,
section,
footer,
aside {
  display: block;
}

.questionLists {
  max-width: 500px;
  min-width: 320px;
  margin: 0 auto;
  position: relative;
  transition: none;
  // background: #ffffff;
  padding-bottom: 60px;
}
/deep/ .van-sticky--fixed {
  width: 100%;
  max-width: 500px;
  min-width: 320px;
  left: auto;
  right: auto;
}
.list-box {
  margin: 0 rem(30) 0;
}
.list-title {
  font-size: rem(34);
  font-weight: 900;
  padding: rem(20) 0 rem(40);
  color: #333;
}
.list-bd {
  position: relative;
  display: flex;
  background: #fff;
  padding: rem(20);
  border-radius: rem(8);
  cursor: pointer;
  min-height: rem(100);
  margin-bottom: rem(20);
}
.list-bd.noborder {
  border-radius: 0 0 rem(8);
}
.list-bd.wrongcard-wrap {
  padding: 0;
  margin-bottom: 0;
  margin-top: rem(20);
  background: none;
}
.list-bd:last-child {
  // margin-bottom: 0;
}
.list-bd .list-icon {
  display: block;
  width: rem(160);
  height: rem(160);
  border-radius: rem(10);
  object-fit: cover;
}
.list-icon-bd {
  position: relative;
}
.list-right {
  flex: 1;
  margin-left: rem(20);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.itle-part {
  display: flex;
  justify-content: space-between;
}
.list-text {
  font-size: rem(32);
  color: #000;
  line-height: 1.5;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  width: rem(400);
}
.list-count {
  font-size: rem(24);
  color: #999;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.list-label {
  padding-right: rem(30);
}
.practice-icon {
  position: absolute;
  left: 0;
  top: rem(40);
  width: rem(103);
  height: rem(41);
}
.top10 {
  top: rem(10);
}
.text-red {
  color: #ff7070 !important;
}
.noData {
  // min-height: calc(100vh - 44px);
  text-align: center;
  padding: rem(60) rem(30);
  box-sizing: border-box;
  line-height: rem(48);
  font-size: rem(28);
  position: relative;
  color: #666666;
  background: #efeff4;
}
.noData .code {
  width: rem(420);
  margin-top: rem(60);
}
/* 模版中心 */
.template-center-left {
  flex: 1;
}
.template-enter {
  display: flex;
  align-items: center;
  margin: rem(16) 0;
}
.template-enter-title {
  font-weight: 700;
  font-size: rem(34);
  line-height: rem(50);
  color: #262626;
  margin-right: rem(20);
}
.template-des {
  font-size: rem(28);
  line-height: rem(28);
  color: #999999;
}
.template-enter img {
  width: rem(50);
  height: rem(50);
}
.template-center-right {
  width: rem(240);
  height: rem(130);
}
.createCard {
  margin: rem(20) 0 rem(20);
}
.contact-wrapper {
  // padding-bottom: 60px;
}
.contact {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 50px;
}
.toIntro {
  cursor: pointer;
}
.tip {
  height: rem(76);
  line-height: rem(76);
  background: rgba(222, 239, 255, 0.6);
  box-shadow: 0 rem(10) rem(16) #f4f6fa;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 rem(30);
  font-size: rem(24);
  cursor: pointer;
}
.refresh-icon {
  width: rem(32);
  height: rem(32);
  margin-right: rem(10);
}
.partner-box {
  display: flex;
  align-items: center;
}
.partner-box.red {
  color: #fe523c;
}
.partner {
  width: rem(26);
  height: rem(26);
  margin-right: rem(10);
}
.more-btn {
  margin-right: rem(30);
  .van-cell {
    padding: 0;
    font-size: rem(24);
    color: #999;
  }
  .van-cell__right-icon {
    font-size: initial;
    margin-left: 0;
    font-size: rem(24);
  }
}
.van-tabs__wrap {
  border-bottom: 1px solid #eeeeee;
}
.qlsearch-box {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  padding: rem(30);
  border-radius: rem(8);
  margin: 0 0 rem(20);
}
.qlsearch-bd {
  flex: 1;
  height: rem(70);
  background: #f6f6f6;
  border-radius: rem(6);
  border-radius: rem(35);
  display: flex;
  align-items: center;
  font-size: rem(26);
  position: relative;
}
.qlsearch-input {
  width: 100%;
  height: 100%;
  border: none;
}
.qlsearch-desc {
  margin: 0 auto;
  display: flex;
  align-items: center;
  color: #999999;
  font-size: rem(28);
}
.qlsearch-bd icon {
  margin: 0 rem(15);
  cursor: pointer;
}
.questStoreWrapper .num {
  display: flex;
  justify-content: space-between;
}
.questStoreWrapper .top-title {
  flex: 1;
}
.qlsearch-bd-input {
  position: absolute;
  left: 0;
  right: 0;
  height: 100%;
  padding-left: rem(60);
  border: none;
}
.search-clear-icon {
  position: absolute;
  right: rem(24);
  z-index: 3;
  width: rem(40);
  height: rem(40);
  cursor: pointer;
}
.title label {
  color: #ff0000;
}

.recovery {
  min-width: rem(160);
  text-align: right;
  margin-left: rem(40);
  position: relative;
  font-size: rem(28);
  cursor: pointer;
}
.recovery-count {
  position: absolute;
  left: rem(15);
  top: rem(-10);
  background: #ff0000;
  color: #ffffff;
  font-size: rem(22);
  height: rem(30);
  line-height: rem(30);
  padding: 0 rem(8);
  border-radius: rem(30);
  z-index: 5;
  display: inline-block;
}
.recovery-btn {
  width: rem(36);
  height: rem(36);
  margin-right: rem(10);
}
.icon-search {
  width: rem(40);
  height: rem(40);
  margin: 0 rem(15);
}

/* 针对Chrome浏览器 */
input[type="search"]::-webkit-search-cancel-button {
  display: none;
}

/* 针对Edge浏览器 */
input[type="search"]::-ms-clear {
  display: none;
}

.login-box {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.login-desc {
  font-size: 15px;
  line-height: 25px;
  color: #999999;
  margin-bottom: 15px;
}
.see-end {
  color: #999999;
  font-size: 13px;
  text-align: center;
  padding: 15px 0;
  background: #ffffff;
}
.typeBox {
  position: absolute;
  left: 0;
  bottom: 0;
  width: rem(100);
  height: rem(38);
  font-size: rem(22) !important;
  background-color: #1890ff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  border-radius: 0 rem(8) 0 rem(8);
  padding: 0 rem(10);
  box-sizing: border-box;
}
.typeBox.r {
  left: 0;
  bottom: 0;
}
.type-icon {
  width: rem(22);
  height: rem(22);
  margin-right: rem(7);
}
.btn-ok {
  color: #1890ff;
}
.handle-btn {
  min-width: rem(40);
  min-height: rem(40);
  max-width: rem(40);
  max-height: rem(40);
  position: relative;
  right: rem(-30);
}
.handleType {
  font-size: rem(28);
  margin-right: rem(30);
}

.handleType-icon {
  transform: rotate(90deg);
  width: rem(16);
  height: rem(24);
  margin-left: rem(16);
}
.recovery-boxpr {
  height: auto;
  position: relative;
  max-width: 500px;
  min-width: 320px;
  font-size: 14px;
  margin: 0 auto;
  background: red;
  position: fixed;
  bottom: 0;
  width: 100%;
}
.recovery-box {
  position: absolute;
  bottom: rem(130);
  right: 0;
  background: #ffffff;
  border: rem(2) solid #f0f0f0;
  box-shadow: 0px rem(1) rem(10) 0 rgba(0, 0, 0, 0.16);
  width: rem(174);
  height: rem(80);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
  border-radius: rem(20) 0 0 rem(20);
}
.recovery {
  min-width: rem(160);
  text-align: right;
  margin-left: rem(40);
  position: relative;
  font-size: rem(28);
}
.recovery-count {
  position: absolute;
  left: rem(15);
  top: -rem(10);
  background: #ff0000;
  color: #ffffff;
  font-size: rem(22);
  height: rem(30);
  line-height: rem(30);
  padding: 0 rem(8);
  border-radius: rem(30);
  z-index: 5;
  display: inline-block;
}
.recovery-btn {
  width: rem(36);
  height: rem(36);
  margin-right: rem(10);
}
</style>



// WEBPACK FOOTER //
// src/pages/questionList/questionList.vue